/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import store from '@/store'
import Vue from 'vue';
import urlencode from "urlencode"
import Cookies from "js-cookie"
// 环境的切换

// axios.defaults.baseURL = '/mapi/';
// // 测试环境和生成环境接口baseURL
// if (process.env.NODE_ENV == 'development') {
//     axios.defaults.baseURL = '/static/';
// } else if (process.env.NODE_ENV == 'production') {  // npm run build
//     axios.defaults.baseURL = 'http://myhost.com/xxx/xxx/';
// }
// 请求超时时间
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token
        const token = localStorage.getItem('token');
        token && (config.headers.Authorization = token);
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
      if (response.status === 200) {
        if (response.data.errcode == 1002) {
          localStorage.removeItem('menu');
          localStorage.removeItem('routers');
          localStorage.removeItem('users');
          axios.post("/mapi/oauth/process?func=getP13LoginConfig&csrfcookie="+ Vue.prototype.$cookie.get('csrfcookie')).then(resp => {
            var currentUrl = urlencode(window.location.origin +'/admin/loginFromP13')
            var url = resp.data.data.getTicketUrl + '?appId=' + resp.data.data.appId + '&service=' + currentUrl
            location.replace(url);
          })

          // Vue.prototype.$message({
          //   message: '当前登录超时，请重新登录后再操作',
          //   type: 'warning',
          //   onClose:() => {
          //     store.dispatch('FedLogOut').then(() => {
          //       location.reload() // 为了重新实例化vue-router对象 避免bug
          //     })
          //   }
          // });
          // localStorage.clear();
          // Cookies.remove('token');
          // Cookies.remove('empno');
        } else  {
          return Promise.resolve(response);
        }

      }else {
        Vue.prototype.$message({
          message: '当前登录超时，请重新登录后再操作',
          type: 'warning',
          onClose:() => {
            store.dispatch('FedLogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          }
        });
        return Promise.reject(response);
      }
        // if (response.status === 200) {
        //     return Promise.resolve(response);
        // } else {
        //     return Promise.reject(response);
        // }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                  Vue.prototype.$message({
                    message: '当前登录超时，请重新登录后再操作',
                    type: 'warning',
                    onClose:() => {
                      store.dispatch('FedLogOut').then(() => {
                        location.reload() // 为了重新实例化vue-router对象 避免bug
                      })
                    }
                  });
                    alert('未登录');
                    break;
                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token和清空vuex中token对象
                    // 跳转登录页面
                case 403:
                    alert('登录过期，请重新登录');
                    break;
                    // 404请求不存在
                case 404:
                    alert('网络请求不存在');
                    break;
                    // 其他错误，直接抛出错误提示
                default:
                    alert('网络请求不存在');
            }
            return Promise.reject(error.response);
        }
    }
);

function request(param) {
  // console.log('param', param);
  if (param.timeout && param.timeout>0){
    axios.defaults.timeout = param.timeout;
  }else{
    axios.defaults.timeout = 10000;
  }

  return new Promise ((resolve, reject)=> {
    // var rs = Math.random().toString(36).slice(-8);
    param.url = "/mapi"+param.url+ "&csrfcookie="+ Vue.prototype.$cookie.get('csrfcookie');
    // Vue.prototype.$cookie.set('csrfcookie', rs);
    axios(param).then(response=> {
      // console.log('response',response)
      // 统一处理200成功后的返回值
      if (response.data.code !== '0' || response.data.code !== '0000') {
        // alert(response.err_msg)
      }
      // 统一处理200成功后的返回值
      resolve(response.data);
    }).catch(err=> {
      reject(err);
    })
  })
}
function requestapi(param) {
  // console.log('param', param);
  return new Promise ((resolve, reject)=> {
    param.url = "/api"+param.url
    axios(param).then(response=> {
      // console.log('response',response)
      // 统一处理200成功后的返回值
      if (response.data.code !== '0' || response.data.code !== '0000') {
        // alert(response.err_msg)
      }
      // 统一处理200成功后的返回值
      resolve(response.data);
    }).catch(err=> {
      reject(err);
    })
  })
}

export {
  request,
  requestapi
}



// /**
//  * get方法，对应get请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
// export function get(url, params) {
//     return new Promise((resolve, reject) => {
//         axios.get(url, {
//                 params: params
//             })
//             .then(res => {
//                 resolve(res.data);
//             })
//             .catch(err => {
//                 reject(err.data)
//             })
//     });
// }
// /**
//  * post方法，对应post请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
// export function post(url, params) {
//     return new Promise((resolve, reject) => {
//         axios.post(url, QS.stringify(params))
//             .then(res => {
//                 resolve(res.data);
//             })
//             .catch(err => {
//                 reject(err.data)
//             })
//     });
// }



// WEBPACK FOOTER //
// ./src/utils/request.js